import { getCodeGenerateMode, wujiCodeModel } from "./codeGenerateModes";
export const defaultProtocol = Object.freeze({
  PAGE: 'page',
  SIZE: 'size',
  CODE: 'code',
  MESSAGE: 'message',
  LIST: 'data',
  LIST_TOTAL: 'total',
  TOTAL: 'data.total',
  ENTITY_DATA: 'data'
});
export function getSourceProtocolBySource(instance) {
  return getSourceProtocol(instance.options.extraConfig || {}, instance.isDB, instance.collection.collectionData);
}
export function getSourceProtocol(extraConfig, isDB, collection) {
  var _collection$settings;
  if (isDB) {
    return defaultProtocol;
  }
  const codeMode = getCodeGenerateMode((_collection$settings = collection.settings) === null || _collection$settings === void 0 ? void 0 : _collection$settings.codeMode).value;
  if (codeMode === wujiCodeModel.value) {
    return defaultProtocol;
  }
  const custom = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.protocol) || {};
  const customValues = Object.keys(custom).reduce((prev, key) => {
    const val = custom[key];
    if (typeof val === 'string' && val.trim().length > 0) {
      prev[key] = val;
    }
    return prev;
  }, {});
  const protocol = {
    ...defaultProtocol,
    ...customValues
  };
  return protocol;
}
//# sourceMappingURL=protocol.js.map
